/**
 * Generate initials from a name string
 * Takes the first letter of the first two words
 * Examples:
 * - "John Smith" -> "JS"
 * - "Jane" -> "JA"
 * - "Star Mountain Capital" -> "SM"
 * - "" -> "--"
 */
export function getInitials(name: string): string {
  if (!name || name.trim() === '' || name === '-') {
    return '--';
  }

  const words = name.trim().split(/\s+/);

  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }

  // Single word: take first two characters
  if (words[0].length >= 2) {
    return words[0].substring(0, 2).toUpperCase();
  }

  return words[0][0].toUpperCase() + words[0][0].toUpperCase();
}
